// extracted by mini-css-extract-plugin
export default {"select":"FormSelector_select__HJeqm"};